import {teamsQueryOptions} from '@blesk-frontend/api';
import {useBleskAuth} from '@blesk-frontend/auth';
import {Button, Close} from '@blesk-frontend/ui';
import {useQuery} from '@tanstack/react-query';
import {useEffect, useMemo, useState} from 'react';

export const changedTeamHintKey = 'changedTeam';

export const ChangedTeamHint = () => {
  const [isTeamChanged, setIsTeamChanged] = useState(false);
  const {
    query: {data: user},
    teamId,
  } = useBleskAuth();
  const {data: teams} = useQuery(teamsQueryOptions());

  const currentTeam = useMemo(() => {
    if (!teams) {
      return null;
    }

    return teams.find((team) => team.id === teamId) || null;
  }, [teams, teamId]);

  useEffect(() => {
    if (!user || !currentTeam) {
      return;
    }

    const teamChangedValue = localStorage.getItem(changedTeamHintKey);

    if (teamChangedValue) {
      setIsTeamChanged(JSON.parse(teamChangedValue));
    }
  }, [user, currentTeam]);

  if (!isTeamChanged) {
    return null;
  }

  const onClickClose = () => {
    setIsTeamChanged(false);
    localStorage.removeItem(changedTeamHintKey);
  };

  return (
    <div className="flex w-full max-w-screen-xl gap-6 rounded-lg border border-border-primary bg-warning-subtle p-6">
      <p className="flex-1 text-paragraph-md text-text-secondary">
        Перед вами рабочее пространство команды «{currentTeam?.name} /{' '}
        {currentTeam?.members.find((member) => member.role === 'owner')?.user.email}».
        <br />
        Для смены команд используйте переключатель в левой колонке.
      </p>
      <Button type="button" variant="link" className="text-text-secondary" onClick={onClickClose}>
        <Close className="size-6" />
      </Button>
    </div>
  );
};
